import Divider from '@eversports/klimt-primitives/legacy/Divider'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

import TeacherCardButton from '../../../../components/TeacherCard/TeacherCardButton'
import TeacherCardContainer from '../../../../components/TeacherCard/TeacherCardContainer'
import { Trainer } from '../../VenueProfile.types'

import TrainerCardInfo from './TrainerCardInfo'

interface Props {
  trainer: Trainer
}

const DisabledTrainerCard = ({ trainer }: Props) => (
  <TeacherCardContainer>
    <Stack gap={4}>
      <TrainerCardInfo trainer={trainer} />
      <Divider sx={{ borderColor: 'ligthgray' }} />
      <TeacherCardButton isActiveAtVenue={false} />
    </Stack>
  </TeacherCardContainer>
)

export default DisabledTrainerCard
